import { gql } from '@apollo/client';

const UPDATE_CATEGORY_PRIORITY = gql`
  mutation updateCategoryPriority($categories: [CategoryPriorityInput!]!) {
    updateCategoryPriority(categories: $categories) 
  }
`;

export { UPDATE_CATEGORY_PRIORITY }
